jQuery(document).ready(function($) {

  // share toggle
  $('.single-home .share span').on('click', function() {
    $('.single-home .actions').addClass('share--is-showing')
  })

  // body clicked - clos esidebar
  $('main').on('click', function(e) {
    if ($('body').hasClass('sidebar--is-open')) {
      $('body').removeClass('sidebar--is-open')
    }
  })

  // print
  $('.single-home .print').on('click', function() {
    window.print()
  })

  // print image
  if ($('.page-template-page-print-image').length > 0) {
    window.print()
  }

  // image share click
  $('.image-share').on('click', function() {
    if (Foundation.MediaQuery.current == 'small') {
      $(this).toggleClass('image--share-is-showing')
    }
  })

  $('.image-share-bar').on('click', function(e) {
    e.stopPropagation()
  })

  // carousel home
  var $carouselHome = $('.carousel-home').flickity({
    cellSelector: Foundation.MediaQuery.atLeast('medium') ? '.image-desktop' : '.image-mobile',
    contain: true,
    pageDots: true,
    prevNextButtons: false,
    percentPosition: false,
    autoPlay: $('.home').length > 0 ? 3250 : 0,
    imagesLoaded: true,
    fade: true,
    setGallerySize: false,
    resize: true,
    wrapAround: true,
    pauseAutoPlayOnHover: false
  })

  $carouselHome.on('select.flickity', function(event, index) {
    $carouselHome.flickity('playPlayer')
  })

  // carousel menu
  var $carouselMenu = $('.carousel-menu').flickity({
    cellSelector: '.carousel-cell',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    percentPosition: false,
    autoPlay: 0,
    imagesLoaded: true,
    fade: true,
    setGallerySize: false,
    resize: true
  })

  // sidebar opener
  $('.sidebar .opener').on('click', function(e) {
    $('body').toggleClass('sidebar--is-open')
  })

  if ($('.home').length > 0) {
    if (Foundation.MediaQuery.atLeast('large')) {
      setTimeout(function() {
        $('.sidebar .opener').trigger('click')
      }, 1000)
    }
  }

  // footer homes
  $('footer a[href="#homes"]').on('click', function() {
    $('body').addClass('sidebar--is-open')
    $('.sidebar .submenu').addClass('submenu--is-showing')
    e.preventDefault()
  })

  // submenu toggler
  $('.sidebar .with-submenu a.trigger').on('click', function(e) {
    $(this).next().toggleClass('submenu--is-showing')
    e.preventDefault()
  })

  // sidebar homes
  $('.submenu-homes a').hover(
    function() {
      var $a = $(this)
      $carouselMenu.flickity('stopPlayer').flickity('select', $a.index())
      $('.carousel-menu-fixed').addClass('carousel-menu-fixed--is-showing')
      $('.carousel-home').addClass('carousel-home--is-hidden')
    },
    function() {
      $('.carousel-menu-fixed').removeClass('carousel-menu-fixed--is-showing')
      $('.carousel-home').removeClass('carousel-home--is-hidden')
    }
  )

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

});
